export interface LegacyApiResponse<T> {
  data: T;
  error?: boolean | string;
  message?: string;
}

export function unwrapLegacyResult<T>(response: LegacyApiResponse<T>, fallbackMessage: string): T {
  if (!response || response.error === true || (response as any).data === false) {
    const message = response && typeof response.message === 'string' && response.message.trim() ? response.message.trim() : fallbackMessage;
    throw { error: { message } };
  }
  return response.data;
}

export function unwrapLegacyData<T>(response: LegacyApiResponse<T>, fallbackMessage: string): T {
  if (!response || response.data == null || (response as any).data === false) {
    const message = response && typeof response.message === 'string' && response.message.trim() ? response.message.trim() : fallbackMessage;
    throw { error: { message } };
  }
  return response.data;
}

export function legacyErrorMessage(error: any, fallback: string): string {
  const body = error && error.error;
  if (typeof body === 'string') {
    try {
      const parsed = JSON.parse(body);
      return (parsed && typeof parsed.message === 'string' && parsed.message.trim()) || fallback;
    } catch {
      return fallback;
    }
  }
  return (body && typeof body.message === 'string' && body.message.trim()) || fallback;
}
